import { ThemeOptions } from "@mui/material";

const typography: ThemeOptions["typography"] = {
  fontFamily: "'Poppins', sans-serif",
};

export const lightThemeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: { main: "#009688" },
    secondary: { main: "#f50057" },
    background: { default: "#eef3ef", paper: "#fff" },
    text: { primary: "#000", secondary: "#555" },
  },
  typography,
};

export const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: { main: "#4db6ac" },
    secondary: { main: "#ff4081" },
    background: { default: "hsl(210, 14%, 7%)", paper: "hsl(210, 14%, 13%)" },
    text: { primary: "#fff", secondary: "#aaa" },
  },
  typography,
};
